// @ts-nocheck
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, Paper, SuccessMessage } from '@olxbr/design-system'

import ScrollView from '../../atoms/ScrollView'
import TermsAndPrivacyNotice from '../../molecules/TermsAndPrivacyNotice'
import medias from '../../../util/medias'
import { ScorePinCodePage } from '../ScorePinCodePage'
import { ScoreCheckPinCodePage } from '../ScoreCheckPinCodePage'
import AccessNavigator, { createNewRouter } from '../AccessNavigator'
import getSessionTokenInfos from '../../../util/sessionTokenGetter'
import { FLOW_TYPES } from '../../../util/global.consts'
import { getUserEmail } from '../../../api/emailInfo'

const Content = styled(View)`
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  margin-top: 64px;
  overflow: hidden;
  margin-bottom: 64px;
  max-width: 466px;
  ${medias.medium`
    margin: 0;
    margin-top: 4px;
    margin-bottom: 0;
  `}

  ${({ modalMode }) => modalMode && `margin-top: 0; margin-bottom: 0; max-width: unset;`}
`

const ContentElement = ({ modalMode, ...props }) => {
  return modalMode ? <View {...props} /> : <Paper {...props} />
}

const CustomPaper = styled(ContentElement)`
  padding: 0;
  ${medias.medium`
    padding: 0;
  `}
  border: 1px solid var(--color-neutral-90);
`

const FooterWrapper = styled(View)`
  display: flex;
  margin-top: 24px;
`

const ScorePinCodeStack = ({
  email: initialEmail,
  token,
  flow,
  onSuccess,
  onSwitchEmail,
  onAccountNotValidated,
  onPhoneNotValidated,
  abTests,
  modalMode,
}) => {
  const [email, setEmail] = useState(initialEmail)
  const [router] = useState(() => createNewRouter('ScorePinCode'))
  const [sessionTokens, setSessionTokens] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')
  const [successMessageOpen, setSuccessMessageOpen] = useState(false)

  useEffect(() => {
    const fetchEmail = async () => {
      if (flow === FLOW_TYPES.SELF_SERVICE && token) {
        const fetchedEmail = await getUserEmail(token)
        setEmail(fetchedEmail)
      }
    }

    fetchEmail()
  }, [flow, token])

  useEffect(() => {
    const fetchSessionTokens = async () => {
      const sessionTokensResult = await getSessionTokenInfos()
      if (sessionTokensResult) {
        setSessionTokens(sessionTokensResult)
      }
    }

    fetchSessionTokens()
  }, [])

  const onSendPinCodeSuccess = () => {
    setSuccessMessage('E-mail enviado!')
    setSuccessMessageOpen(true)
    router.push('ScoreCheckPinCode')
  }

  const onResend = () => {}

  const renderScorePinCode = () => (
    <ScorePinCodePage
      onSuccess={onSendPinCodeSuccess}
      token={token}
      email={email}
      flow={flow}
      onSwitchEmail={onSwitchEmail}
      modalMode={modalMode}
      abTests={abTests}
    />
  )

  const renderScoreCheckPinCode = () => (
    <ScoreCheckPinCodePage
      email={email}
      token={token}
      flow={flow}
      onSuccess={onSuccess}
      onResend={onResend}
      onSwitchEmail={onSwitchEmail}
      onAccountNotValidated={onAccountNotValidated}
      onPhoneNotValidated={onPhoneNotValidated}
      abTests={abTests}
      sessionTokens={sessionTokens}
      modalMode={modalMode}
    />
  )

  return (
    <ScrollView>
      <Content modalMode={modalMode}>
        <CustomPaper modalMode={modalMode}>
          <AccessNavigator
            router={router}
            routes={[
              {
                route: 'ScorePinCode',
                component: renderScorePinCode,
              },
              {
                route: 'ScoreCheckPinCode',
                component: renderScoreCheckPinCode,
              },
            ]}
          />
          <SuccessMessage
            text={successMessage}
            show={successMessageOpen}
            onClose={() => setSuccessMessageOpen(false)}
          />
        </CustomPaper>
        <FooterWrapper>
          <TermsAndPrivacyNotice />
        </FooterWrapper>
      </Content>
    </ScrollView>
  )
}

ScorePinCodeStack.propTypes = {
  email: PropTypes.string,
  token: PropTypes.string,
  flow: PropTypes.string,
  onSuccess: PropTypes.func,
  onSwitchEmail: PropTypes.func,
  onAccountNotValidated: PropTypes.func,
  onPhoneNotValidated: PropTypes.func,
  abTests: PropTypes.string,
  modalMode: PropTypes.bool,
}

export { ScorePinCodeStack }
